import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'NOTIFS_SETTINGS_PAGE_LOAD',
    'NOTIFS_SETTINGS_PAGE_SUBMIT',
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
